import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";
import { invalidateShiftQueries } from "./invalidateShiftQueries";

export function useEditShiftMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: plantoesApi.edit,
    onSuccess: () => invalidateShiftQueries(queryClient),
  });
}
